<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      viewBox="0 0 24 24"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1778 2.17865C13.1778 1.86605 13.0536 1.56626 12.8326 1.34522C12.6116 1.12418 12.3118 1 11.9992 1C11.6866 1 11.3869 1.12418 11.1658 1.34522C10.9448 1.56626 10.8206 1.86605 10.8206 2.17865V10.8221C10.8206 11.1346 10.9448 11.4344 11.1658 11.6555C11.3869 11.8765 11.6866 12.0007 11.9992 12.0007C12.3118 12.0007 12.6116 11.8765 12.8326 11.6555C13.0536 11.4344 13.1778 11.1346 13.1778 10.8221V2.17865ZM7.15921 4.83767C7.29223 4.75314 7.40695 4.64278 7.49657 4.51313C7.58619 4.38348 7.6489 4.23716 7.68099 4.08285C7.71308 3.92853 7.71389 3.76935 7.68338 3.61472C7.65287 3.46008 7.59165 3.31314 7.50336 3.18258C7.41506 3.05202 7.30148 2.9405 7.16933 2.85461C7.03718 2.76872 6.88914 2.71021 6.73399 2.68255C6.57883 2.65488 6.41969 2.65861 6.26601 2.69353C6.11232 2.72845 5.96719 2.79384 5.83921 2.88583C3.8884 4.20477 2.41231 6.11495 1.62803 8.33544C0.843749 10.5559 0.792688 12.9695 1.48235 15.2212C2.17202 17.4728 3.56601 19.4438 5.45929 20.844C7.35258 22.2443 9.64521 23 12 23C14.3548 23 16.6474 22.2443 18.5407 20.844C20.434 19.4438 21.828 17.4728 22.5176 15.2212C23.2073 12.9695 23.1563 10.5559 22.372 8.33544C21.5877 6.11495 20.1116 4.20477 18.1608 2.88583C18.0327 2.79752 17.8884 2.73545 17.7361 2.70321C17.5839 2.67096 17.4268 2.66918 17.2739 2.69796C17.121 2.72674 16.9753 2.78552 16.8452 2.8709C16.7151 2.95628 16.6032 3.06657 16.516 3.19542C16.4288 3.32426 16.3679 3.46911 16.3369 3.6216C16.3059 3.77409 16.3055 3.9312 16.3355 4.08388C16.3656 4.23656 16.4255 4.38177 16.512 4.51115C16.5984 4.64052 16.7097 4.7515 16.8392 4.83767C18.3723 5.87376 19.5325 7.37454 20.149 9.11925C20.7655 10.864 20.8059 12.7605 20.2641 14.5299C19.7224 16.2992 18.6271 17.848 17.1395 18.9484C15.6518 20.0487 13.8503 20.6426 12 20.6426C10.1497 20.6426 8.34817 20.0487 6.86053 18.9484C5.37289 17.848 4.27764 16.2992 3.73589 14.5299C3.19414 12.7605 3.23449 10.864 3.85102 9.11925C4.46754 7.37454 5.62611 5.87376 7.15921 4.83767Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconOn',
  };
  </script>
  
  <style scoped>
  .icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    fill: inherit;
    flex-shrink: 0;
  }
  </style>
  